import { render, staticRenderFns } from "./AfkirDini.vue?vue&type=template&id=6983a062&"
import script from "./AfkirDini.vue?vue&type=script&lang=js&"
export * from "./AfkirDini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports